export default "__VITE_ASSET__UIvtRJHe__"